module.exports = __webpack_public_path__ + "static/media/error.e4dbb32a.svg";